// Global stores registered on init
document.addEventListener('alpine:init', () => {
  Alpine.store('theme', {
    current: 'light',

    toggle() {
      if (this.current === 'light') { 
        this.current = 'dark'
      } else {
        this.current = 'light'
      }
    }
})  
});

document.addEventListener('alpine:init', () => {
  if (typeof Alpine === 'undefined') return;

  Alpine.data('ticker', () => ({
    offset: 0,
    speed: 0.5,
    start() {
      const animate = () => {
        this.offset -= this.speed;
        const trackWidth = this.$refs.track.scrollWidth / 2;
        if (Math.abs(this.offset) >= trackWidth) {
          this.offset = 0;
        }
        requestAnimationFrame(animate);
      };
      animate();
    }
  }));
});

document.addEventListener('alpine:init', () => {
  Alpine.data('slideCarousel', (slideCount) => ({
    active: 1, // Start at 1 (first real slide, after the cloned last)
    slides: slideCount,
    translateX: 0, // ⭐ Start at 0 to show cloned last slide immediately
    isMobile: false,
    isTransitioning: false,
    transition: 'transform 0.5s ease',
    
    touchStartX: 0,
    touchStartY: 0,
    touchEndX: 0,
    touchEndY: 0,
    isDragging: false,
    minSwipeDistance: 50,
    
    init() {
      this.checkMobile();
      // Only apply infinite loop if more than 1 slide
      if (this.slides > 1) {
        this.active = 1;
        this.transition = 'none'; // ⭐ No transition on init
        this.updateSlides();
      } else {
        this.active = 0;
        this.translateX = 0;
      }
      
      window.addEventListener('resize', () => {
        this.checkMobile();
        this.updateSlides();
      });
    },
    
    next() {
      if (this.isTransitioning || this.slides <= 1) return;
      
      this.isTransitioning = true;
      this.transition = 'transform 0.5s ease';
      this.active++;
      this.updateSlides();
      
      // ⭐ Jump back when reaching cloned first slide (seamless loop)
      if (this.active > this.slides) {
        setTimeout(() => {
          this.transition = 'none'; // Disable transition for instant jump
          this.active = 1;
          this.updateSlides();
          this.isTransitioning = false;
        }, 500); // Wait for slide animation to complete
      } else {
        setTimeout(() => {
          this.isTransitioning = false;
        }, 500);
      }
    },
    
    prev() {
      if (this.isTransitioning || this.slides <= 1) return;
      
      this.isTransitioning = true;
      this.transition = 'transform 0.5s ease';
      this.active--;
      this.updateSlides();
      
      // ⭐ Jump back when reaching cloned last slide (seamless loop)
      if (this.active < 1) {
        setTimeout(() => {
          this.transition = 'none'; // Disable transition for instant jump
          this.active = this.slides;
          this.updateSlides();
          this.isTransitioning = false;
        }, 500); // Wait for slide animation to complete
      } else {
        setTimeout(() => {
          this.isTransitioning = false;
        }, 500);
      }
    },
    
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    
    updateSlides() {
      if (!this.isMobile && this.slides > 1) {
        const slideWidth = 75; // 70% slide + 5% margin
        this.translateX = -(this.active * slideWidth);
      } else if (!this.isMobile) {
        this.translateX = 0;
      }
    },
    
    handleTouchStart(e) {
      if (this.isTransitioning) return;
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.isDragging = true;
    },
    
    handleTouchMove(e) {
      if (!this.isDragging) return;
      
      const deltaX = Math.abs(e.touches[0].clientX - this.touchStartX);
      const deltaY = Math.abs(e.touches[0].clientY - this.touchStartY);
      
      if (deltaX > deltaY) {
        e.preventDefault();
      }
    },
    
    handleTouchEnd(e) {
      if (!this.isDragging) return;
      
      this.touchEndX = e.changedTouches[0].clientX;
      this.touchEndY = e.changedTouches[0].clientY;
      this.isDragging = false;
      
      this.handleSwipe();
    },
    
    handleSwipe() {
      const deltaX = this.touchEndX - this.touchStartX;
      
      if (Math.abs(deltaX) > this.minSwipeDistance) {
        if (deltaX > 0) {
          this.prev();
        } else {
          this.next();
        }
      }
    },
    
    handleMouseDown(e) {
      if (this.isTransitioning) return;
      
      this.touchStartX = e.clientX;
      this.touchStartY = e.clientY;
      this.isDragging = true;
      
      const handleMouseMove = (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
      };
      
      const handleMouseUp = (e) => {
        if (!this.isDragging) return;
        
        this.touchEndX = e.clientX;
        this.touchEndY = e.clientY;
        this.isDragging = false;
        
        this.handleSwipe();
        
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
      
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }
  }));
});